import * as Yup from 'yup';

export const CreateUserValidation = Yup.object().shape({
  name: Yup.string().required("This field is required"),
  role: Yup.string().required("This field is required"),
  email: Yup.string()
    .email("Invalid email format")
    .required("This field is required"),
});